import { useAtomValue } from 'jotai';
import { createSignEventAtom } from '../../../store/global/atoms/sign-atoms/';

export const useCreateSignEvent = () => {
  const createSignEventSignDocument = useAtomValue(createSignEventAtom);

  return {
    htmlSignDocumentUpdatedData: createSignEventSignDocument.data,
    createSignEvent: createSignEventSignDocument.mutate,
    createSignEventAsync: createSignEventSignDocument.mutateAsync,
    error: createSignEventSignDocument.error,
    isLoading: createSignEventSignDocument.isPending,
  };
};
